import clsx from 'clsx';
import React, { FC, memo, useEffect, useState } from 'react';

import zip from '../../../utils/zip';

type digit = string | number;

type Props = {
  value: string | number;
};

/** Returns JSX of the ticker value, and animate the value depending on the previous value */
function getStyledTickerValue(a: digit[], b: digit[]) {
  const val = Number(a.join(''));
  const prevVal = Number(b.join(''));
  const animationClassName =
    val > prevVal ? 'animate-ticker-up' : 'animate-ticker-down';
  const res = zip(a, b);

  return res.map(([curr, prev], i) => (
    <span
      // eslint-disable-next-line react/no-array-index-key
      key={`${i}-${curr}`}
      // If the number is different, trigger the animation class
      className={clsx('inline-block', curr === prev ? '' : animationClassName)}
    >
      {curr}
    </span>
  ));
}

const Ticker: FC<Props> = ({ value }) => {
  const [tickerValue, setTickerValue] = useState<digit[]>([]);
  const [prevTickerValue, setPrevTickerValue] = useState<digit[]>(tickerValue);

  useEffect(() => {
    setTickerValue(value.toString().split(''));

    return () => {
      setPrevTickerValue(value.toString().split(''));
    };
  }, [value]);

  return <>{getStyledTickerValue(tickerValue, prevTickerValue)}</>;
};

export default memo(Ticker);
